const tableActions ={
    INSERT : "Insert",
    UPDATE : "Update",
    DELETE : "Delete",
    GET : "get",
    UPSERT :"Upsert",
    FILTER :"filter"
}

export default tableActions